export const facilitiesData = [
  {
    id: "littleton",
    shortname: "Littleton Home",
    name: "Littleton Home - Assisted Living",
    location: "5310 W Geddes Ave, Littleton, CO 80128",
    placeId: "ChIJF3blTGt-a4cRGt4WrdFgjUM",
    mapLink: "https://maps.app.goo.gl/j2amWf2J8xfuMqrr8",
    images: [
      {
        src: "/facilities/littleton/littleton.jpg",
        alt: "Front entrance of Littleton facility",
        caption: "Front Entrance",
      },
      // {
      //   src: "/facilities/littleton/garden.jpg",
      //   alt: "Beautiful garden area",
      //   caption: "Therapeutic Garden",
      // },
      // {
      //   src: "/facilities/littleton/living-room.jpg",
      //   alt: "Cozy living room",
      //   caption: "Common Living Area",
      // },
      // {
      //   src: "/facilities/littleton/bedroom.jpg",
      //   alt: "Comfortable bedroom",
      //   caption: "Private Bedroom",
      // },
      // {
      //   src: "/facilities/littleton/dining.jpg",
      //   alt: "Dining area",
      //   caption: "Dining Room",
      // },
    ],
    beds: 8,
    specialty: "Assisted Living",
    description:
      "A cozy ranch style home with an open layout, beautiful backyard and a peaceful vegetable garden, perfectl for comfort, relaxation and rehab support.",
    detailedDescription:
      "Located in the heart of the downtown district, Garden Manor combines the convenience of urban amenities with the tranquility of our specially designed memory care environment. Our 120-bed facility features state-of-the-art security systems, wandering prevention technology, and therapeutic programming designed to enhance quality of life for residents with memory impairments.",
    amenities: [
      "Secure Memory Care Units",
      "Therapeutic Gardens",
      "Art Therapy Studio",
      "24/7 Nursing Care",
      "Sensory Stimulation Room",
      "Family Education Center",
      "Respite Care Services",
      "Pet Therapy Program",
    ],
    services: [
      "Specialized Memory Care",
      "Alzheimer's and Dementia Care",
      "Behavioral Management",
      "Cognitive Stimulation Activities",
      "Family Support Groups",
      "Medical Management",
      "Physical Therapy",
      "Nutrition Support",
    ],
    floorPlans: [
      { name: "Studio Suite", size: "350 sq ft", price: "$4,200/month" },
      { name: "One Bedroom", size: "450 sq ft", price: "$4,800/month" },
      { name: "Companion Suite", size: "600 sq ft", price: "$7,200/month" },
    ],
    staff:
      "Our memory care team includes specialized nurses, certified dementia practitioners, and activity therapists trained in evidence-based approaches to memory care.",
    phone: "(720) 999-7773",
    email: "info@almondtreeseniorcare.com",
  },
  {
    id: "highlands-ranch",
    shortname: "Highlands Home",
    name: "Highlands Ranch - Assisted Living",
    location: "9896 Keenan St, Highlands Ranch, CO 80130",
    placeId: "ChIJQYrTxo2EbIcR--59Oxw_b-0",
    mapLink: "https://maps.app.goo.gl/b6NLYGo8hG4GXfmv6",
    images: [
      {
        src: "/facilities/highlands-ranch/highlandsranch.png",
        alt: "Modern exterior",
      },
      // { src: "/facilities/highlands-ranch/pool.jpg", alt: "Swimming pool" },
      // { src: "/facilities/highlands-ranch/gym.jpg", alt: "Fitness center" },
    ],
    beds: 8,
    specialty: "Assisted Living",
    description:
      "Luxury assisted living home with modern design and easy access to neighborhood walking trail, perfect for seniors.",
    detailedDescription:
      "Perched along the scenic riverside, Sunrise Villa provides an upscale independent living experience for seniors who value their independence but want access to services and amenities. Our 85-unit community features spacious apartments, fine dining, and a full calendar of activities and social events.",
    amenities: [
      "Stunning River Views",
      "Resort-Style Swimming Pool",
      "Golf Simulator Room",
      "State-of-the-Art Fitness Center",
      "Fine Dining Restaurant",
      "Library and Computer Center",
      "Game Room and Billiards",
      "Beauty Salon and Spa",
    ],
    services: [
      "Independent Living Support",
      "Concierge Services",
      "Transportation Services",
      "Housekeeping",
      "Maintenance Services",
      "Social Activities",
      "Fitness Programs",
      "Wellness Screenings",
    ],
    floorPlans: [
      { name: "One Bedroom", size: "650 sq ft", price: "$2,800/month" },
      { name: "Two Bedroom", size: "950 sq ft", price: "$3,600/month" },
      { name: "Premium Suite", size: "1,200 sq ft", price: "$4,500/month" },
    ],
    staff:
      "Our team includes lifestyle coordinators, fitness instructors, and support staff dedicated to helping residents live their best life.",
    phone: "(720) 999-7773",
    email: "info@almondtreeseniorcare.com",
  },
  {
    id: "centennial",
    shortname: "Centennial Home",
    name: "Centennial Home - Memory Care",
    location: "7364 S Fillmore Cir, Centennial, CO 80122",
    placeId: "ChIJR3D8AFmBbIcRxPLGauFr3_4",
    mapLink: "https://maps.app.goo.gl/EBwsEZwSu85Crsyt9",
    images: [
      {
        src: "/facilities/centennial/atsc-centennial.JPG",
        alt: "Modern exterior",
      },
      // { src: "/facilities/centennial/pool.jpg", alt: "Swimming pool" },
      // { src: "/facilities/centennial/gym.jpg", alt: "Fitness center" },
    ],
    beds: 8,
    specialty: "Memory Care",
    description:
      "Warm comforting memory care in a small, intimate home design for residents who benefit from close support and supervision.",
    detailedDescription:
      "Peaceful Pines sits on 15 acres of beautiful forested land, providing residents with nature trails, gardens, and peaceful outdoor spaces. Our assisted living community focuses on helping residents maintain their independence while providing the support they need for daily activities.",
    amenities: [
      "Nature Trails and Gardens",
      "Pet-Friendly Environment",
      "Cozy Library",
      "Chapel and Quiet Spaces",
      "Arts and Crafts Studio",
      "Outdoor Patios",
      "Bird Watching Areas",
      "Community Vegetable Garden",
    ],
    services: [
      "Personal Care Assistance",
      "Medication Management",
      "Healthcare Coordination",
      "Nutritious Meal Service",
      "Housekeeping and Laundry",
      "Transportation Services",
      "Social Activities",
      "Wellness Programs",
    ],
    floorPlans: [
      { name: "Studio", size: "400 sq ft", price: "$3,200/month" },
      { name: "One Bedroom", size: "550 sq ft", price: "$3,800/month" },
      { name: "Two Bedroom", size: "750 sq ft", price: "$4,600/month" },
    ],
    staff:
      "Our caring team includes registered nurses, certified nursing assistants, and activity coordinators who provide personalized attention to each resident.",
    phone: "(720) 999-7773",
    email: "info@almondtreeseniorcare.com",
  },
  {
    id: "centennial-2",
    shortname: "Centennial Home II",
    name: "Centennial Home II - Memory Care",
    location: "7021 S Ash Cir, Centennial, CO 80122",
    placeId: "ChIJARgyR1OBbIcR9XgwAhAgVfw",
    mapLink: "https://maps.app.goo.gl/gthCAHd3Nyie2wZt5",
    images: [
      {
        src: "/facilities/centennial-2/ATSC-centennial-II.JPG",
        alt: "Modern exterior",
      },
      // { src: "/facilities/centennial-2/pool.jpg", alt: "Swimming pool" },
      // { src: "/facilities/centennial-2/gym.jpg", alt: "Fitness center" },
    ],
    beds: "#",
    specialty: "Memory Care ",
    description:
      "Our flagship facility specializing in memory care with beautiful gardens, mountain views and secured memory care facility.",
    detailedDescription:
      "With breathtaking mountain views from every room, Harmony Heights combines clinical excellence with a healing environment. Our 110-bed skilled nursing facility provides 24/7 medical care, rehabilitation services, and long-term care for residents with complex medical needs.",
    amenities: [
      "Panoramic Mountain Views",
      "Modern Rehabilitation Center",
      "Physical Therapy Gym",
      "Occupational Therapy Kitchen",
      "Speech Therapy Room",
      "Respiratory Care Unit",
      "Medical Equipment and Technology",
      "Healing Gardens",
    ],
    services: [
      "Skilled Nursing Care",
      "Post-Hospital Recovery",
      "Physical Therapy",
      "Occupational Therapy",
      "Speech Therapy",
      "Respiratory Therapy",
      "Wound Care Management",
      "Pain Management",
    ],
    floorPlans: [
      { name: "Semi-Private Room", size: "200 sq ft", price: "$6,500/month" },
      { name: "Private Room", size: "300 sq ft", price: "$7,800/month" },
      { name: "Premium Suite", size: "450 sq ft", price: "$9,200/month" },
    ],
    staff:
      "Our medical team includes registered nurses, licensed practical nurses, certified nursing assistants, and rehabilitation therapists available 24/7.",
    phone: "(720) 999-7773",
    email: "info@almondtreeseniorcare.com",
  },
];

export type FacilityId = keyof typeof facilitiesData;
